import { Body } from '#/components/Text/Body';
import { H1 } from '#/components/Text/H1';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { MainChartData } from '#/modules/salary/types/MainChartData';
import { colors } from '#/theme/theme';

type CareerPathHeaderProps = {
  data: MainChartData;
};

export function CareerPathHeader({ data }: CareerPathHeaderProps) {
  const { i18n } = useI18n();

  return (
    <>
      <H1 color={colors.black} styleAs="h2" textAlign="center" mb="12px">
        {data.submittedData?.city
          ? i18n('Explore Your Career Path in %(workLocation)s', {
              workLocation: `${data.submittedData.city}, ${data.submittedData.stateCode}`,
            })
          : i18n('Explore Your Career Path')}
      </H1>
      <Body lineHeight={1.5} color={colors.black} textAlign="center">
        <em>
          {i18n(
            'See what you could be earning in related roles as you level up your skills and experience.',
          )}{' '}
        </em>
      </Body>
    </>
  );
}
